import { cn } from "@/lib/utils";

interface ChipRowProps {
  label?: string;
  options: string[];
  selected: string | string[];
  multiSelect?: boolean;
  onSelect: (value: string | string[]) => void;
}

export function ChipRow({ label, options, selected, multiSelect = false, onSelect }: ChipRowProps) {
  const selectedArr = Array.isArray(selected) ? selected : selected ? [selected] : [];

  const toggle = (opt: string) => {
    if (multiSelect) {
      const next = selectedArr.includes(opt)
        ? selectedArr.filter((v) => v !== opt)
        : [...selectedArr, opt];
      onSelect(next);
    } else {
      onSelect(selectedArr.includes(opt) ? "" : opt);
    }
  };

  return (
    <div className="space-y-1.5">
      {label && <p className="text-xs font-medium text-muted-foreground">{label}</p>}
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => {
          const isActive = selectedArr.includes(opt);
          return (
            <button
              key={opt}
              type="button"
              onClick={() => toggle(opt)}
              className={cn(
                "px-3 py-1.5 rounded-full text-xs font-medium transition-colors border",
                isActive
                  ? "bg-[#3b2314] text-[#f5ecd7] border-[#3b2314]"
                  : "bg-[#f5ecd7]/60 text-foreground/80 border-border hover:bg-[#f5ecd7]"
              )}
            >
              {opt}
            </button>
          );
        })}
      </div>
    </div>
  );
}
